module.exports = __webpack_public_path__ + "common/sidebar/icon-convenience-store-8c879623d8ddfb832ac1eddbb9b47acf.svg";